module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    staticClass: "change_password",
    attrs: {
      "title": "修改密码",
      "size": "small",
      "visible": _vm.dialogVisible
    },
    on: {
      "close": _vm.close,
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "rules": _vm.rules,
      "model": _vm.form
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "oldPassword",
      "error": _vm.errors.first('oldPassword')
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "placeholder": _vm.$t('placeholder.user.oldPassword')
    },
    model: {
      value: (_vm.form.oldPassword),
      callback: function($$v) {
        _vm.form.oldPassword = $$v
      },
      expression: "form.oldPassword"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "newPassword",
      "error": _vm.errors.first('newPassword')
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "name": "password",
      "placeholder": _vm.$t('placeholder.user.newPassword')
    },
    model: {
      value: (_vm.form.newPassword),
      callback: function($$v) {
        _vm.form.newPassword = $$v
      },
      expression: "form.newPassword"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "passwordConfirmation",
      "error": _vm.errors.first('passwordConfirmation')
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "placeholder": _vm.$t('placeholder.user.passwordConfirmation')
    },
    model: {
      value: (_vm.form.passwordConfirmation),
      callback: function($$v) {
        _vm.form.passwordConfirmation = $$v
      },
      expression: "form.passwordConfirmation"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "footer",
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("确定")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3c7b3878"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/profile/account/change_password.dialog.vue
// module id = 912
// module chunks = 3